import * as httpHelper from '../../utils/http-helper';

function inicializar() {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get<{
    Nome: string,
    Endereco: string,
    Logo: string,
    CNPJ: String,
    Configuracoes: {
      ID: number,
      Descricao: string,
      Valor: string,
    }[]
  }>(headers, "Config");
}

function renovarUsuario(cpf: string) {
  const headers = httpHelper.defaultHeaders();

  const params = {
    Login: cpf,
  };

  return httpHelper.post(headers, params, "Cooperado/Atualizar");
}

const inicializarService = {
  inicializar,
  renovarUsuario,
}

export default inicializarService;
